import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { Typography } from "@mui/material"

export default function CompetenceInfoDimension() {
	const { competence } = UseContextsCompetence()
	return (
		<Typography sx={{ whiteSpace: "pre-line" }}>{competence?.dimensiones}</Typography>
	)
	// return (
	// 	<List disablePadding>
	// 		{competence?.dimensiones?.map((characteristic, index) => (
	// 			<Fragment key={characteristic.id}>
	// 				<ListItem disableGutters sx={{ py: 1 }}>
	// 					<ListItemIcon sx={{ minWidth: 32 }}>
	// 						<FiberManualRecordIcon
	// 							sx={{
	// 								fontSize: 8,
	// 								color: "primary.main",
	// 								mt: 1,
	// 							}}
	// 						/>
	// 					</ListItemIcon>
	// 					<ListItemText
	// 						primary={characteristic.name}
	// 						primaryTypographyProps={{
	// 							variant: "body1",
	// 							color: "text.primary",
	// 						}}
	// 					/>
	// 					<Chip
	// 						label={characteristic.active ? "activa" : "desactivada"}
	// 						color={characteristic.active ? "success" : "error"}
	// 						size="small"
	// 						sx={{ ml: 2 }}
	// 					/>
	// 					<Divider />
	// 				</ListItem>
	// 				<Divider />
	// 			</Fragment>
	// 		))}
	// 	</List>
	// )
}
